import { EnhancedRouteProps } from 'router/routes/Enhanced/Enhanced.route';
import SponsoredAdverts from './subrouters/SponsoredAdverts';
import sponsoredAdversRoutes from './subrouters/SponsoredAdverts/routes';
import AdminDashboard from './pages/AdminDashboard';
import BrokerList from './pages/BrokerList';
import BossModeStats from './pages/BossModeStats';
import ListingMetrics from './pages/ListingMetrics';
import EnterpriseRouter from './subrouters/Enterprises';
import enterpriseRoutes from './subrouters/Enterprises/routes';
import ProfileRouter, { profileRouterRoutes } from '../Profile';
import { RoutingStep } from 'router/models/Routes';
import BossModeAccounts from './pages/BossModeAccounts';
import ActivityMetrics from './pages/ActivityMetrics';
import { IconProp } from 'models/Icon';
import SpeakerphoneIcon from 'icons/Speakerphone.icon';
import GroupUsersIcon from 'icons/GroupUsers.icon';
import AddProfileIcon from 'icons/AddProfile.icon';
import ReportsIcon from 'icons/Reports.icon';
import PulseIcon from 'icons/Pulse.icon';
import ChecklistIcon from 'icons/Checklist.icon';
import BuildingIcon from 'icons/Building.icon';
import bossModeStatsRoutes from './pages/BossModeStats/routes';
import Sellers from './pages/Sellers';
import BriefcaseIcon from 'icons/Briefcase.icon';

const bossModeEditProfileRoutes = profileRouterRoutes.filter(
  ({ path }: RoutingStep) => path !== 'account',
);

type AdminDashobardRoutes = EnhancedRouteProps & {
  labelString?: string;
  labelDescription?: string;
  Icon: IconProp;
};

export default [
  {
    path: 'sponsored-adverts',
    element: SponsoredAdverts,
    routes: sponsoredAdversRoutes,
    labelString: 'sponsoredAdverts',
    labelDescription: 'sponsoredAdvertsDescription',
    Icon: SpeakerphoneIcon,
  },
  {
    path: 'broker-list',
    element: BrokerList,
    labelString: 'addABroker',
    labelDescription: 'addABrokerDescription',
    Icon: AddProfileIcon,
  },
  {
    path: 'boss-mode-stats',
    element: BossModeStats,
    labelString: 'bossModeOperations',
    labelDescription: 'bossModeOperationsDescription',
    Icon: ReportsIcon,
    routes: bossModeStatsRoutes,
  },
  {
    path: 'listing-metrics',
    element: ListingMetrics,
    labelString: 'listingMetrics',
    labelDescription: 'listingMetricsDescription',
    Icon: ChecklistIcon,
  },
  {
    path: 'activity-metrics',
    element: ActivityMetrics,
    labelString: 'dealMetrics',
    labelDescription: 'dealMetricsDescription',
    Icon: PulseIcon,
  },
  {
    path: 'enterprise',
    element: EnterpriseRouter,
    routes: enterpriseRoutes,
    labelString: 'manageEnterprises',
    labelDescription: 'enterpriseDescription',
    Icon: BuildingIcon,
  },
  {
    path: 'boss-mode-accounts',
    element: BossModeAccounts,
    labelString: 'editBossModeAccounts',
    labelDescription: 'bossModeAccountsDescription',
    Icon: GroupUsersIcon,
  },
  {
    path: 'seller-connect',
    element: Sellers,
    labelString: 'sellers',
    labelDescription: 'sellersDescription',
    Icon: BriefcaseIcon,
  },
  {
    path: 'edit-profile/:id',
    element: ProfileRouter,
    routes: bossModeEditProfileRoutes,
  },
  { index: true, element: AdminDashboard },
] as Array<AdminDashobardRoutes>;
